import React from "react";

export default function Maintannace() {
	return (
		<div className="maintenance-root">
			<style>{`
				@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Manrope:wght@400;600;700;800&display=swap');

				* {
					box-sizing: border-box;
				}

				.maintenance-root {
					min-height: 100vh;
					padding: 24px;
					color: #f8fbff;
					font-family: 'Manrope', 'Segoe UI', sans-serif;
					background:
						radial-gradient(circle at 15% 20%, rgba(255, 173, 74, 0.32), transparent 35%),
						radial-gradient(circle at 85% 12%, rgba(19, 160, 133, 0.28), transparent 38%),
						radial-gradient(circle at 75% 88%, rgba(62, 123, 255, 0.24), transparent 40%),
						linear-gradient(140deg, #071226 0%, #0b1b37 45%, #152848 100%);
					display: flex;
					align-items: center;
					justify-content: center;
					overflow: hidden;
					position: relative;
					animation: hueShift 14s linear infinite;
				}

				.orb {
					position: absolute;
					border-radius: 50%;
					filter: blur(2px);
					opacity: 0.45;
					pointer-events: none;
					mix-blend-mode: screen;
				}

				.orb-1 {
					width: 240px;
					height: 240px;
					background: radial-gradient(circle, rgba(255, 173, 74, 0.45), rgba(255, 173, 74, 0));
					top: 10%;
					left: -80px;
					animation: floatA 9s ease-in-out infinite;
				}

				.orb-2 {
					width: 260px;
					height: 260px;
					background: radial-gradient(circle, rgba(94, 199, 255, 0.5), rgba(94, 199, 255, 0));
					bottom: 5%;
					right: -90px;
					animation: floatB 11s ease-in-out infinite;
				}

				.maintenance-grid {
					width: min(920px, 100%);
					border: 1px solid rgba(255, 255, 255, 0.2);
					border-radius: 28px;
					padding: clamp(24px, 4vw, 42px);
					background: rgba(9, 18, 35, 0.58);
					backdrop-filter: blur(10px);
					box-shadow: 0 26px 70px rgba(0, 0, 0, 0.45);
					display: grid;
					grid-template-columns: 1.2fr 0.8fr;
					gap: 24px;
					position: relative;
					z-index: 1;
					animation: cardIn .9s cubic-bezier(.2, .8, .2, 1);
				}

				.badge {
					display: inline-flex;
					align-items: center;
					gap: 8px;
					border-radius: 999px;
					padding: 7px 14px;
					font-size: 11px;
					letter-spacing: 1.2px;
					text-transform: uppercase;
					background: rgba(255, 173, 74, 0.18);
					border: 1px solid rgba(255, 173, 74, 0.55);
					color: #ffd59a;
					font-weight: 700;
				}

				.badge-dot {
					width: 8px;
					height: 8px;
					border-radius: 50%;
					background: #ffad4a;
					animation: pulse 1.8s infinite;
				}

				h1 {
					margin: 16px 0 10px;
					font-size: clamp(30px, 5vw, 50px);
					line-height: 1.05;
					font-family: 'Space Grotesk', 'Manrope', sans-serif;
					letter-spacing: -0.03em;
					animation: rise .8s ease both;
				}

				.accent {
					color: #73f3d2;
				}

				.subtitle {
					margin: 0;
					font-size: clamp(14px, 1.9vw, 18px);
					line-height: 1.65;
					color: rgba(238, 246, 255, 0.84);
					max-width: 56ch;
					animation: rise .8s .1s ease both;
				}

				.launch-note {
					margin-top: 12px;
					font-size: 14px;
					font-weight: 700;
					letter-spacing: 0.02em;
					color: #d5f8ee;
					display: inline-flex;
					align-items: center;
					gap: 8px;
					animation: rise .8s .18s ease both;
				}

				.spark {
					font-size: 15px;
					animation: twinkle 1.5s ease-in-out infinite;
				}

				.progress-wrap {
					margin-top: 18px;
					width: min(460px, 100%);
					height: 10px;
					background: rgba(255, 255, 255, 0.12);
					border: 1px solid rgba(255, 255, 255, 0.2);
					border-radius: 999px;
					overflow: hidden;
				}

				.progress-fill {
					height: 100%;
					width: 45%;
					border-radius: inherit;
					background: linear-gradient(90deg, #ffad4a 0%, #73f3d2 55%, #5ec7ff 100%);
					background-size: 180% 100%;
					animation: progressMove 4.2s ease-in-out infinite, shimmer 2.2s linear infinite;
				}

				.progress-text {
					margin-top: 8px;
					font-size: 12px;
					color: rgba(221, 234, 255, 0.78);
					letter-spacing: 0.05em;
					text-transform: uppercase;
				}

				.status-box {
					border: 1px solid rgba(115, 243, 210, 0.45);
					background: rgba(115, 243, 210, 0.1);
					border-radius: 14px;
					padding: 14px 15px;
					margin-top: 20px;
					font-size: 14px;
					display: inline-flex;
					align-items: center;
					gap: 10px;
					color: #c8fff2;
					font-weight: 600;
					animation: rise .8s .25s ease both;
				}

				.status-dot {
					width: 10px;
					height: 10px;
					border-radius: 50%;
					background: #73f3d2;
					box-shadow: 0 0 0 0 rgba(115, 243, 210, 0.75);
					animation: ping 2.1s infinite;
				}

				.panel {
					border-radius: 16px;
					background: rgba(255, 255, 255, 0.07);
					border: 1px solid rgba(255, 255, 255, 0.2);
					padding: 18px;
					align-self: center;
					animation: rise .8s .34s ease both;
				}

				.panel h2 {
					margin: 0 0 10px;
					font-size: 15px;
					letter-spacing: 0.04em;
					text-transform: uppercase;
					color: rgba(255, 255, 255, 0.8);
				}

				.task {
					margin: 8px 0;
					font-size: 13px;
					color: rgba(228, 239, 255, 0.86);
					display: flex;
					align-items: center;
					gap: 9px;
				}

				.task::before {
					content: "";
					width: 8px;
					height: 8px;
					border-radius: 50%;
					background: #5ec7ff;
					box-shadow: 0 0 12px rgba(94, 199, 255, 0.9);
				}

				.task:nth-child(2)::before { animation: dotPulse 1.4s ease-in-out infinite; }
				.task:nth-child(3)::before { animation: dotPulse 1.4s .25s ease-in-out infinite; }
				.task:nth-child(4)::before { animation: dotPulse 1.4s .5s ease-in-out infinite; }
				.task:nth-child(5)::before { animation: dotPulse 1.4s .75s ease-in-out infinite; }

				.footer-note {
					margin-top: 20px;
					font-size: 12px;
					color: rgba(221, 234, 255, 0.72);
					letter-spacing: 0.04em;
					text-transform: uppercase;
				}

				@keyframes pulse {
					0%, 100% { opacity: 1; transform: scale(1); }
					50% { opacity: 0.5; transform: scale(1.5); }
				}

				@keyframes ping {
					0% { box-shadow: 0 0 0 0 rgba(115, 243, 210, 0.7); }
					70% { box-shadow: 0 0 0 14px rgba(115, 243, 210, 0); }
					100% { box-shadow: 0 0 0 0 rgba(115, 243, 210, 0); }
				}

				@keyframes hueShift {
					0% { filter: hue-rotate(0deg); }
					50% { filter: hue-rotate(8deg); }
					100% { filter: hue-rotate(0deg); }
				}

				@keyframes floatA {
					0%, 100% { transform: translateY(0px) translateX(0px); }
					50% { transform: translateY(-16px) translateX(14px); }
				}

				@keyframes floatB {
					0%, 100% { transform: translateY(0px) translateX(0px); }
					50% { transform: translateY(18px) translateX(-10px); }
				}

				@keyframes rise {
					from { opacity: 0; transform: translateY(12px); }
					to { opacity: 1; transform: translateY(0); }
				}

				@keyframes cardIn {
					from { opacity: 0; transform: scale(.98) translateY(10px); }
					to { opacity: 1; transform: scale(1) translateY(0); }
				}

				@keyframes progressMove {
					0%, 100% { width: 45%; }
					50% { width: 82%; }
				}

				@keyframes shimmer {
					0% { background-position: 0% 0%; }
					100% { background-position: 180% 0%; }
				}

				@keyframes twinkle {
					0%, 100% { opacity: .6; transform: scale(.9); }
					50% { opacity: 1; transform: scale(1.12); }
				}

				@keyframes dotPulse {
					0%, 100% { transform: scale(1); opacity: .75; }
					50% { transform: scale(1.28); opacity: 1; }
				}

				@media (max-width: 840px) {
					.maintenance-grid {
						grid-template-columns: 1fr;
						gap: 18px;
					}
				}
			`}</style>

			<div className="orb orb-1" />
			<div className="orb orb-2" />

			<main className="maintenance-grid" role="main" aria-live="polite">
				<section>
					<div className="badge">
						<span className="badge-dot" />
						Maintenance In Progress
					</div>

					<h1>
						Please wait.<br />
						We are <span className="accent">working on it</span>.
					</h1>

					<p className="subtitle">
						Our team is currently upgrading the application to improve speed, reliability, and your overall experience.
						Thank you for your patience.
					</p>

					<p className="launch-note">
						<span className="spark">✦</span>
						Our model will be published very soon.
					</p>

					<div className="progress-wrap" aria-label="maintenance progress animation">
						<div className="progress-fill" />
					</div>
					<p className="progress-text">Final checks in progress</p>

					<div className="status-box">
						<span className="status-dot" />
						Service status: temporary maintenance mode
					</div>

					<p className="footer-note">Brand Monitoring Platform</p>
				</section>

				<aside className="panel" aria-label="maintenance tasks">
					<h2>Current Work</h2>
					<p className="task">Server stability improvements</p>
					<p className="task">Database optimization</p>
					<p className="task">UI and API performance tuning</p>
					<p className="task">Security patch verification</p>
				</aside>
			</main>
		</div>
	);
}

